import React from 'react';
import {
  OrderForm,
  FlexRowStartStretch,
  FlexColumnStartStretch,
  BackButton,
} from "components";
import PropTypes from 'prop-types';
import { 
  withRouter,
} from "react-router-dom";

class OrderCreate extends React.Component{

  static propTypes={
    history:PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state={
    };

  }

  componentDidMount(){
  }

  componentWillUnmount(){
  }

  render(){
    return (      
        <FlexColumnStartStretch>
          <FlexRowStartStretch>
            <BackButton parentProps={this.props}/>
          </FlexRowStartStretch>
          <OrderForm history={this.props.history}/>
        </FlexColumnStartStretch>
    );
  }
}


export default withRouter(OrderCreate);
